import React, { createContext } from 'react';

export const AUTHENTICATION = 'AUTH/authentication';
export const LOGIN = 'AUTH/login';
export const LOGIN_SSO = 'AUTH/login_sso';
export const FORGOT_PASSWORD_SEND = 'AUTH/forgot_password_send_email';
export const FORGOT_PASSWORD_SET = 'AUTH/forgot_password_set_new';
export const VALIDATE_FORGOT_PASSWORD = 'AUTH/validate_forgot_password';

export const REGISTER = 'AUTH/register';
export const PROFILE = 'AUTH/profile';
export const CHANGE_PASSWORD = 'AUTH/change_password';
export const CREATE_ACCOUNT = 'AUTH/create_account';
export const CURRENT_ACCOUNT = 'AUTH/current_account';
export const TOGGLE_MODE = 'ACCOUNT/toggle_mode';
export const CONFIRM_CURRENT_PASSWORD = 'AUTH/confirm_current_password';
export const RESEND_EMAIL_VERIFICATION = 'ACCOUNT/resend_email_verification';

export const MyAccountContext = createContext();
export const ProfileContext = createContext();

export const termsAndDefinitions = [
  {
    title: '"Account"',
    description:
      'means any account of a Subscriber with the Service Provider with respect to the provision of any Service;',
  },
  {
    title: '"Add-Ons"',
    description:
      'means any additional product or service purchased by the Subscriber to supplement their Plan;',
  },
  {
    title: '“Activation/Activated”',
    description:
      'means the point in time when the said Service is Activated by the Service Provider.',
  },
  {
    title: '"AITI"',
    description:
      'means the Authority for Info-communications Technology Industry of Brunei Darussalam;',
  },
  {
    title: '“Authorised Centre”',
    description:
      'means any commercial establishment, place or branch of the Service Provider as listed on https://www.dst.com.bn/dst-branches-1 where its Services are made available;',
  },
  {
    title: '”Approved Authority”',
    description:
      'means any Federal, State or Local Government, quasi-government authorities, departments, statutory bodies, state corporations or other bodies (including but not limited to any corporations or private agencies licensed with authority under any written law in Brunei Darussalam to exercise its rights or jurisdiction in connection with or affecting the enforcement of the Terms and/or any matter arising out of the Terms;',
  },
  {
    title: '"Bill"',
    description:
      'means any bill, invoice or statement issued or rendered by the Service Provider of any charge, fee or other sum stated therein as due and/or payable to the Service Provider and/or of the sum or sums or balance due and/ or payable to the Service Provider in respect of any Service or on any Account;',
  },
  {
    title: '“Brunei Dollar”',
    description: 'means the lawful currency of Brunei Darussalam;',
  },
  {
    title: '“Bundle”',
    description:
      'means any additional products, services including but not limited to devices, data, minutes that is packaged or also known as Contract Plans;',
  },
  {
    title: '“Business Day”',
    description:
      'means a day (other than a Saturday or a public holiday in Brunei Darussalam) on which banks are generally open in Brunei and “Business Days” shall be construed accordingly’;',
  },
  {
    title: '“Business Hours”',
    description:
      'means from 8:00 a.m. to 6:00 p.m. from Monday to Friday (excluding public holidays);',
  },
  {
    title: '“Contract Plan”',
    description:
      'means any postpaid mobile (MOBI) plan, mobile wireless (FREEDOM) or fixed broadband plan (INFINTIY) or any other contract provided by the Service Provider in a Bundle that includes a leased device that is subject to a minimum mandatory term;',
  },
  {
    title: '“Credit Balance”',
    description:
      'means the amount of credit available on any Prepaid mobile Plan;',
  },
  {
    title: '“my dst Account”',
    description:
      'means the DST account registered on the website which may be used on other Platforms including the apps',
  },
  {
    title: '“eBill”',
    description:
      'means the electronic Bill received by the Subscriber from the Service Provider via email, on it’s Platform or any other electronic medium introduced by the Service Provider from time to time;',
  },
  {
    title: '"Equipment"',
    description:
      'means any electronic devices, equipment or things owned, provided, operated, installed and/or hired out by Datastream Digital Sdn Bhd in relation to the Service, and does not include the handset devices leased as part of any Contract Plan;',
  },
  {
    title: '“Fair Use Policy”',
    description:
      'means the fair use policy issued and published on https://www.dst.com.bn/ of which may be updated by the Service Provider from time to time;',
  },
  {
    title: '"Fees and Charges"',
    description:
      'means fees, charges and/or rental in connection with provision of any Service and/or Equipment;',
  },
  {
    title: '"General Terms"',
    description:
      'means this General Terms which stipulates the primary terms and conditions prescribed or imposed by the Service Provider which includes any schedules, annexures and/or appendices referred herein;',
  },
  {
    title: '“Guarantee”',
    description:
      'means a bank guarantee required by the Service Provider for the Activation of a Contract Plan of any Subscriber of foreign nationality, as determined and stipulated within these Terms;',
  },
  {
    title: '“Law”',
    description:
      'means the telecommunication order of Brunei Darussalam and any other laws, guidelines, practice direction and/or directives issued and enforced by the relevant authorities of Brunei Darussalam which governs, controls and manages the telecommunication, media and technology industry;',
  },
  {
    title: '“Loyalty Programs”',
    description:
      'means the rewards program offered by the Service Provider such as for Subscribers on Postpaid Contract Plans;',
  },
  {
    title: '“Non-Contract Plan”',
    description:
      'means any postpaid mobile plan, fixed broadband or any other contract provided by the Service Provider without, additional obligations and/or minimum mandatory term;',
  },
  {
    title: '“Platform”',
    description:
      'means any electronic medium in which the Service Provider makes available its services, including but not limited to its website, portal or applications;',
  },
  {
    title: '“Plan”',
    description:
      'means any Plan whether prepaid mobile (EASI), postpaid mobile (MOBI), mobile wireless broadband (FREEDOM), or fixed broadband (INFINITY) collectively or either of them as the context may require;',
  },
  {
    title: '"Pre-Paid Fees"',
    description:
      'means monies paid into an Account and credited to a Subscriber, from which Fees and Charges are deducted at the time of accrual without the issue of any Bill relating to those Fees and Charges;',
  },
  {
    title: '"Prescribed Rate"',
    description: 'means an interest rate of two (2) percent per month;',
  },
  {
    title: '“Recharge Card”',
    description:
      'means the coupon, voucher, card or any other receipt which functions as a valid means to replenish the Credit Balance of any prepaid mobile Plan;',
  },
  {
    title: '“Registration Forms”',
    description:
      'means the relevant application forms and documentations the Subscriber must submit along with any supplementary information requested to process the Service requested;',
  },
  {
    title: '“Service”',
    description:
      'means any telecommunication, broadcasting, broadband or other related facilities and services (including the supply, rental or installation of any electronic devices and equipment comprise in any Subscriber Request), offered or provided by the Service Provider from time to time;',
  },
  {
    title: '"Service Number"',
    description: () => (
      <div>
        means any number or alphanumeric symbols or characters assigned by the
        Service Provider or selected by the Subscriber for the purpose of:
        <ol>
          <li>
            (a) the provision to or utilisation by the Subscriber of any Service
            and/or Equipment; and/or
          </li>
          <li>
            (b) identifying the Subscriber (whether to any telecommunications
            system or facility operated by Service Provider to any other system
            or facility operated by any other person) for the purpose of or in
            relation to any Service,
          </li>
        </ol>
        including telephone number, mailbox number, e-mail number or address,
        network user identity, password and circuit reference number;
      </div>
    ),
  },
  {
    title: '"Service Provider"',
    description:
      'means Datastream Digital Sdn Bhd and/or its group of companies, including its successors in title and assigns, which contracts or agrees with the Subscriber to provide or make available that Service;',
  },
  {
    title: '"Specific Terms"',
    description:
      'means any additional terms and conditions prescribed or imposed by the Service Provider stipulated under any subscription or application form or document of which the Subscriber is required to execute and/or accept, with respect to the provision of the particular Service;',
  },
  {
    title: '“Submitted Material”',
    description:
      'means any content or material disclosed by the Subscriber to the Service Provider through the Platform or by other means;',
  },
  {
    title: '“Subscriber”',
    description:
      'means a person who subscribes to the Service under the Subscriber Agreement;',
  },
  {
    title: '"Subscriber Agreement"',
    description:
      'means any agreement containing Specific Terms or otherwise, entered between the Service Provider and the Subscriber relating to any specific Service or Equipment which primary terms and condition are always made pursuant to or inadherence with the General Terms;',
  },
  {
    title: '"Subscriber Request"',
    description:
      'means any request, order or instruction of the Subscriber to the Service Provider (whether with respect to any Service or otherwise);',
  },
  {
    title: '"Taxes"',
    description:
      'means all taxes, duties, levies, and other similar charges (and any related interest and penalties) however designated, imposed under any laws of Brunei Darussalam or the laws of any jurisdiction outside Brunei Darussalam with respect to the provision of any Services or on any Fees and Charges or payment due or payable to the Service Provider from the Subscriber; and',
  },
  {
    title: '“Terms”',
    description: 'means the General Terms and Specific Terms collectively.',
  },
];
